import { createUseStyles } from 'react-jss';

const styles = {
  messageBlock: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  message: {
    fontSize: '1.6rem',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
